module.exports = __webpack_public_path__ + "static/7-a75ee275556b3965e9259f325281ef26.jpg";